<template>
    <div>
<!--         <object id="nsd" classid="clsid:149D3194-E118-47D9-9737-D17D2A44683F" -->
<!--             codebase="/static/js/nsd/nsd.cab#Version=1,0,0,23" width="0" height="0"> -->
<!--         </object> -->
    </div>
</template>

<script>
import Vue                                  from 'vue';

import axios from 'axios';
import { SDLUtil, DateUtil, CertUtil } from '@/utils';

import qs from 'query-string';
import { EventBus } from '@/utils/EventBus';

import * as NSD from '/static/js/nsd/nsdPlugin';

export default {
    name: 'hhp-drm-auth',
    components: {},
    props: [],
    data() {
        return {
            isLoading: true,

            userId: '',
            randomStr: '',

            nsdReturnCode: null,
            STORE_MSEDGE : 'https://microsoftedge.microsoft.com/addons/detail/nasca-server-drm/enfbagebehlaeomhfohjefkfodanciim',
            STORE_CHROME : 'https://chrome.google.com/webstore/detail/nasca-server-drm/jnobgabnnbdhjompaagbfbjiimplamll',
        };
    },
    computed: {},

    created() {
    	this.init();
    },
    mounted() {
    },

    methods: {
        async init() {
            SDLUtil.showLoadingBar(true);
            const data = await this.fetchInitData(false);
            SDLUtil.showLoadingBar(false);
            this.setData(data);
            this.isLoading = false;
//CB Trustnet Client 교체
//             if (!SDLUtil.isIE11()) {
//                SDLUtil.alert({ msg: 'Internet Explorer 11 is required to download and view files with DRM.' });
//                return;

//             } else {
//                 this.drmSetting(this.userId, this.randomStr);
//             }
            this.drmSetting(this.userId, this.randomStr);
        },

        fetchInitData() {
            const path = '/basis/certificate/CertLoginSuccess.skp';
            return SDLUtil.getRequest(path, {
                // otp_update_yn: otpUpdate,
            });
        },
        
        setData(data) {
            // this.otp_update_yn = data.otp_update_yn || 'N';
            // this.gspn_yn = data.gspn_yn || 'N';
            // this.use_yn = data.use_yn || 'N';
            // this.imei_pw = data.imei_pw || '';
            // this.imei_pw_masking = data.imei_pw_masking || '';
            // this.valid_time = data.valid_time || '';
            this.nsdReturnCode = data.nsdReturnCode;
            this.userId = data.userId;
            this.randomStr = data.randomStr;
        },
        
// CB NASCA Server DRM WS 2022.10.14            
        async drmSetting(userId = '', randVar = ''){
        	const chkPlugin = new Promise((resolve) => {
        		nsdPlugin.actNSD("IsN", "1", function(ret){
       				resolve(ret);
       			});
       		});
        	
        	let ret = await chkPlugin;
        	
        	if( ret == "0" || ret == "1") { // NASCA 설치 됨 - 패치 점검
        		const base = "2021051714";//chrome, edge만 사용, Edge-IE모드 사용불가
//                 const ret2 = nsd.actNSD("IsN", "2");
				const chkClientVer = new Promise((resolve) => {
	        		nsdPlugin.actNSD("IsN", "2", function(ret){
	       				resolve(ret);
	       			});
	       		});
	        	
	        	let ret2 = await chkClientVer;
                if ( parseInt(ret2) < parseInt(base) ) {
                    // alert("DRM NASCA Patch!");
//                     SDLUtil.alert({
// 	                    title: 'NASCA Client Required',
//                         msg: 'Please install a new version of NASCA<br><p style="color:red;">After installation, restart the browser.</p>',
//                     });
//                     return;
                	SDLUtil.confirm({
	                    title: 'NASCA Client Required',
                        msg: 'Please install NASCA Client<br><p style="color:red;">After installation, restart the browser.</p>',
	        			okLabel: 'Download',
	        			cancelLabel: 'Done',
	        			onOkEvt: () => {
	                        window.open('https://skp.samsungcsportal.com/static/setup/NSD_5.00_2022070420.exe', '_blank');
	        			},
	        			onCancelEvt: () => {
	        				
	        			},
	        		});
	        		return;
                }
            } else if( ret == "2"){ // ActivX 사용시 NASCA 설치, 서버DRM 미지원  통합본 설치 
                SDLUtil.alert({
                    title: 'NASCA Client Required',
                    msg: 'Please install NASCA Client( NASCA 32/64Bit OS ) to view files with DRM lock.',
                });
                return;
            } else if( ret == "3"){ // ActivX 사용시 NASCA 미설치 - 단독본 설치유도
                // alert("DRM Non-NASCA Install!");
                SDLUtil.alert({
                    title: 'NASCA Client Required',
                    msg: 'Please install NASCA Client( NASCA 32/64Bit OS ) to view files with DRM lock.',
                });
                return;
            } else if( ret == "4"){ // ActivX 미사용시 NASCA 미설치 - 설치유도
                // alert("DRM Non-NASCA Install!");
//                 SDLUtil.alert({
//                     title: 'NASCA Client Required',
//                     msg: 'Please install NASCA Client(Non-NASCA 32/64Bit OS) to view files with DRM lock.<br><p style="color:red;">After installation, restart the browser.</p>',
//                 });
//                 return;
            	SDLUtil.confirm({
                    title: 'NASCA Client Required',
                    msg: 'Please install NASCA Client<br><p style="color:red;">After installation, restart the browser.</p>',
        			okLabel: 'Download',
        			cancelLabel: 'Done',
        			onOkEvt: () => {
                        window.open('https://skp.samsungcsportal.com/static/setup/NSD_5.00_2022070420.exe', '_blank');
        			},
        			onCancelEvt: () => {
        				
        			},
        		});
        		return;
            } else {
            	if( ret == "-2" ){
	        		SDLUtil.confirm({
	        			title: 'Plugin Required',
	        			msg: 'After installation of DRM Plugin,<br><p style="color:red;">restart the browser.</p>',
	        			okLabel: 'Download',
	        			cancelLabel: 'Done',
	        			onOkEvt: () => {
// 	        				let userAgent = navigator.userAgent.toLowerCase();
// 	        				if(userAgent.indexOf('edg')> 0){
// 		                        window.open(this.STORE_MSEDGE, '_blank');
// 				            } else if(userAgent.indexOf('whale')> 0){
// 		                        window.open(this.STORE_MSEDGE, '_blank');
// 				            } else {
		                        window.open(this.STORE_CHROME, '_blank');
// 				            }
	        			},
	        			onCancelEvt: () => {
	        				
	        			},
	        		});
	        		return;
	            } else { // 오류 발생
	                // alert("DRM Install Fail!");
	                SDLUtil.alert({
	                    title: 'Plugin Error',
	                    msg: 'Error occured while detecting NASCA plugin.<br>Please restart the browser and try again.',
	                });
	                return;
	            }        	
            }
            //////////////////////////////////////
            // DRM 사용자 인증 부분
            const drmSet = new Promise((resolve) => {
	            // NASCA 서버DRM 적용을 위한 업무시스템 개발자 가이드-20220630 P29 사용자 인증 연계  마지막에 ";" 붙이지 않음.
// 	            let commandData = randVar + ";C1000005002;" + userId +";SCMS_DEV;SCMS_DEV;sec;N;112.106.189.228;80;112.106.189.228;15080";
				// 개발 테스트 할때 . 
	            let commandData = randVar + ";C1000015002;" + userId +";SCMS_DEV;SCMS_DEV;sec;N;112.106.186.158;80;112.106.186.158;15080";
// 	            let commandData = randVar + ";C1000005002;" + userId +";SCMS;SCMS;sec;N;112.106.186.158;80;112.106.186.158;15080";
	            if (process.env.NODE_ENV === 'prod') {
	            	// 2021 qa 
	            	//commandData = randVar + ";C1000015002;" + userId +";SCMS;SCMS;sec;N;112.106.186.158;80;112.106.186.158;15080";
	                // 2021 운영
	                commandData = randVar + ";C1000005002;" + userId +";SCMS;SCMS;sec;N;112.106.186.158;80;112.106.186.158;15080";
	            }
	            console.log('▶ DRM Auth commandData', commandData);
        		nsdPlugin.actNSD("SetOnX", commandData , function(ret){
       				resolve(ret);
       			});
       		});
            
            let rtnDrmSet = await drmSet;
            console.log('▶ DRM Auth nsdPlugin.actNSD("SetOnX") returned', rtnDrmSet);        	
            if ( rtnDrmSet == "1" ) {				
                // SUCCESS
            } else {
                SDLUtil.alert({
                    title: 'NASCA Plugin Error',
                    msg: 'Error occurred while connecting to NASCA server.<br>Please restart the browser and try again.<br>Error Code: ' + rtnDrmSet,
                });
            }			
        },

        drmSetting_20221014(userId = '', randVar = '') {
            //////////////////////////////////////
            // ActiveX 차단 에러처리
            let nsdActive = false;
            try{
                if( new ActiveXObject('NSDACTVX.NSDActvXCtrl.1') ) {
                    nsdActive = true;
                }
            } catch(e) {
            }
        
            if(nsdActive == false) {
                SDLUtil.confirm({
                    title: 'Plugin Required',
                    msg: 'Please install/run NASCA plugin to view files with DRM lock.<br>Your browser may have attempted to install/run the plugin automatically.<br>Please download the plugin and install it if the automatic installation has failed.',
                    okLabel: 'Download',
                    cancelLabel: 'Done',
                    onOkEvt: () => {
                        window.open('http://skp.samsungcsportal.com/basis/anysvcmobile/fasoo/cab/NSD_ActiveX_Installer.exe', '_blank');
                    },
                    onCancelEvt: () => {
                    },
                });
                return;
            }
        
            //////////////////////////////////////
            // 설치 유도 부분
            let ret = nsd.actNSD("IsN", "1");	
            var t = (ret=="1"?"N":"S");
        
            if( ret == "0" || ret == "1") { // NASCA 설치 됨 - 패치 점검
                const base = "2014072802";
                const ret2 = nsd.actNSD("IsN", "2");
                if ( parseInt(ret2) < parseInt(base) ) {
                    // alert("DRM NASCA Patch!");
                    SDLUtil.alert({
                        title: 'Plugin Required',
                        msg: 'Please install a new version of NASCA',
                    });
                    // displayDrmInstall();
                    return;
                }
            } else if( ret == "2"){ // 구버전 NASCA 설치됨 - 패치 유도
                SDLUtil.alert({
                    title: 'Plugin Required',
                    msg: 'Please install a new version of NASCA',
                });
                // displayDrmInstall();
                return;
            } else if( ret == "3"){ // NASCA 미설치 - 단독본 설치유도
                // alert("DRM Non-NASCA Install!");
                SDLUtil.alert({
                    title: 'Plugin Required',
                    msg: 'Please install NASCA plugin to view files with DRM lock.',
                });
                // displayDrmInstall();
                return;
            } else { // 오류 발생
                // alert("DRM Install Fail!");
                SDLUtil.alert({
                    title: 'Plugin Error',
                    msg: 'Error occured while detecting NASCA plugin.<br>Please restart the browser and try again.',
                });
                return;
            }

            //2020 개발
            let commandData = randVar + ";C1000005002;" + userId +";SCMS_DEV;SCMS_DEV;sec;N;112.106.189.228;80;112.106.189.228;15080;";
            if (process.env.NODE_ENV === 'prod') {
            	// 2021 qa 
            	//commandData = randVar + ";C1000015002;" + userId +";SCMS;SCMS;sec;N;112.106.186.158;80;112.106.186.158;15080;";
                // 2021 운영
                commandData = randVar + ";C1000005002;" + userId +";SCMS;SCMS;sec;N;112.106.186.158;80;112.106.186.158;15080;";
            }

            Vue.$log.info('▶ DRM Auth commandData', commandData);

            //////////////////////////////////////
            // DRM 사용자 인증 부분
            ret = nsd.actNSD("SetOnX", commandData);
            if ( ret == "1" ) {				
                // SUCCESS
            } else {
                SDLUtil.alert({
                    title: 'NASCA Plugin Error',
                    msg: 'Error occurred while connecting to NASCA server.<br>Please restart the browser and try again.<br>Error Code: ' + ret,
                });
            }			
            Vue.$log.info('▶ DRM Auth nsd.actNSD("SetOnX") returned', ret);
        },
    },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/certificate/DrmAuth.vue